import {Ice} from 'ice';
import {render} from 'react-dom';
require<() => void>("react-tap-event-plugin")();
import {Provider} from 'react-redux';
import {browserHistory} from 'react-router';
import {syncHistoryWithStore} from "react-router-redux";
import {composeWithDevTools} from 'redux-devtools-extension';
import {enhancerOptions} from 'ice-redux-devtools';
import {
  getMuiTheme, lightBaseTheme, MuiThemeProvider,
} from "material-ui/styles";
import {
  createStore, applyMiddleware, compose, GenericStoreEnhancer,
} from 'redux';
import sagaMiddlewareFactory from 'redux-saga';
import {routerMiddleware} from "react-router-redux";
import createIceClient from "@neolab/ice-client";

import AppRouter from "./router";
import ConnectionBar from './components/ConnectionBar';
import iceClientConfig from "./iceClientConfig";
import createReducer from './reducers';
import rootSaga from './sagas';

const composeEnhancers = composeWithDevTools(enhancerOptions);

function startApp() {
  const iceClient = createIceClient(iceClientConfig);

  const sagaMiddleware = sagaMiddlewareFactory({
    context: {iceClient},
  });

  const reducer = createReducer(iceClient);

  const store = createStore(reducer,
    composeEnhancers(
      applyMiddleware(
        sagaMiddleware,
        routerMiddleware(browserHistory),
      ),
    ),
  );

  sagaMiddleware.run(rootSaga);

  if (module.hot) {
    module.hot.accept('./reducers', () =>
      store.replaceReducer(createReducer(iceClient)),
    );
  }

  const history = syncHistoryWithStore(browserHistory, store);

  const app = document.createElement('div');

  document.body.appendChild(app);

  const renderApp = () => {
    render(<MuiThemeProvider muiTheme={getMuiTheme(lightBaseTheme)}>
      <Provider store={store}>
        <div>
          <AppRouter history={history}/>
          <ConnectionBar/>
        </div>
      </Provider>
    </MuiThemeProvider>, app);
  };

  renderApp();

  if (module.hot) {
    module.hot.accept('./router', () => renderApp());
  }
}


startApp();



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/index.tsx